import { lazy, ComponentType } from 'react';

const RELOAD_FLAG = 'chunk-reload-attempted';

export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
) {
  return lazy(async () => {
    try {
      const module = await factory();
      sessionStorage.removeItem(RELOAD_FLAG);
      return module;
    } catch (err: any) {
      const isChunkError =
        err?.name === 'ChunkLoadError' ||
        /Loading chunk [\d]+ failed/i.test(err?.message ?? '') ||
        /Loading CSS chunk [\d]+ failed/i.test(err?.message ?? '');

      if (!isChunkError) throw err;

      await new Promise((r) => setTimeout(r, 800));
      try {
        const module = await factory();
        sessionStorage.removeItem(RELOAD_FLAG);
        return module;
      } catch (retryErr) {
        if (sessionStorage.getItem(RELOAD_FLAG) === '1') throw retryErr;
        sessionStorage.setItem(RELOAD_FLAG, '1');
        window.location.reload();
        return new Promise<never>(() => {});
      }
    }
  });
}
